module.exports = __webpack_public_path__ + "img/icon2s.91dc715d.png";